<template>
  <div>
    <b-row>
      <b-col>
        <h2>{{ $t('message.addressDetails.title') }}</h2>
      </b-col>
    </b-row>
    <div v-if="!isEditable">
      <b-row class="mt-4">
        <b-col>
          <Infobox
            v-if="currentAddress"
            :title="title"
            :subtitle="subtitle"
            variant="noHover">
            <span class="infobox-icon ti-home"></span>
          </Infobox>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-btn variant="link" @click="back">{{ $t('message.addressDetails.btn.back') }}</b-btn>
        </b-col>
        <b-col class="text-right">
          <b-btn variant="primary" @click="editAddress">{{ $t('message.addressDetails.btn.edit') }}</b-btn>
          <b-btn variant="danger" v-b-modal.delete-address-model>{{ $t('message.addressDetails.btn.delete') }}</b-btn>
        </b-col>
      </b-row>
      <div
        v-if="isPolicyHolder"
        class="mt-5">
        <b-row>
          <b-col>
            <contracts-card
              collapseId="addressContracts"
              :title="$t('message.addressDetails.contractsCard.title')"
              :items="contractsByAddress"
              @showDetails="onShowDetails">
            </contracts-card>
          </b-col>
        </b-row>
        <b-row v-if="contractsByAddress.length !== 0">
          <b-col>
            <b-card
              class="rounded-0 mt-4"
              :title="$t('message.addressDetails.moveTitle')">
              <b-row>
                <b-col v-if="isSingleAddress">
                  {{ $t('message.addressDetails.moveMessageSingleAddr') }}
                </b-col>
                <b-col v-if="!isSingleAddress">
                  {{ $t('message.addressDetails.moveMessage') }}
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-row
                    v-for="i in Math.ceil(filteredAddresses.length / 3)"
                    class="mt-3"
                    :key="i">
                    <b-col
                      v-for="address in filteredAddresses.slice((i - 1) * 3, i * 3)"
                      :key="address.id">
                      <b-btn
                        variant="transparent"
                        class="p-0 my-2 mr-4 rounded-0 btn-address w-100"
                        @click="onSelectAddressbox(address)">
                        <Infobox
                          :title="getTitle(address)"
                          :subtitle="address.postalCode + ' ' + address.city"
                          :class="getAddressBoxClass(address)">
                          <span class="infobox-icon ti-home"></span>
                        </Infobox>
                      </b-btn>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row v-if="!isSingleAddress">
                <b-col class="text-right">
                  <b-btn variant="primary"
                         :disabled="contractsByAddress.length === 0 || !newAddress"
                         @click="updateContractsWithAddress">
                    {{ $t('message.addressDetails.moveBtn') }}
                  </b-btn>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else>
      <b-row class="mt-4">
        <b-col cols="10">
          <address-form
            ref="addressForm"
            :address="currentAddress"
            :onSubmitFn="saveAddress">
          </address-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="10"
          class="text-right px-4">
          <b-btn
            variant="link"
            @click="cancel">
            {{ $t('message.addressDetails.btn.cancel') }}
          </b-btn>
          <b-btn
            variant="primary"
            @click="saveAddress">
            {{ $t('message.addressDetails.btn.save') }}
          </b-btn>
        </b-col>
      </b-row>
    </div>
    <b-modal id="delete-address-model"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.addressDetails.modal.title')"
             :ok-title="$t('message.addressDetails.modal.btn.ok')"
             :cancel-title="$t('message.addressDetails.modal.btn.cancel')"
             @ok="deleteAddress">
      <p class="mt-4">{{ $t('message.addressDetails.modal.question') }}</p>
    </b-modal>
  </div>
</template>
<script>
  import AddressForm from '@/components/address/AddressForm'
  import ContractsCard from '@/components/contracts/ContractsCard'
  import Infobox from '@/components/common/Infobox'

  export default {
    name: 'AccountDetails',
    components: {
      AddressForm,
      ContractsCard,
      Infobox
    },
    computed: {
      isSingleAddress () {
        if (this.addresses.length === 1) {
          return true
        }
        return false
      },
      addresses () {
        return this.$store.getters.addresses
      },
      filteredAddresses () {
        return this.$store.getters.addresses.filter(address => address.id !== this.currentAddress.id)
      },
      contractsByAddress () {
        return this.$store.getters.contractsByAddress
      },
      currentAddress () {
        return this.$store.getters.currentAddress
      },
      isContactPerson () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesContactPerson = currentUser.roles.filter(role => role.roleOfUser === 'CONTACT_PERSON')
          if (rolesContactPerson.length > 0) {
            return true
          }
        }
        return false
      },
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      title () {
        return this.currentAddress.street + ' ' + this.currentAddress.streetNumber
      },
      subtitle () {
        return this.currentAddress.postalCode + ' ' + this.currentAddress.city
      }
    },
    data () {
      return {
        isEditable: false,
        newAddress: null
      }
    },
    created () {
      const id = parseInt(this.$route.params.id)
      if (id) {
        const filteredAddresses = this.addresses.filter(address => address.id === id)
        if (filteredAddresses.length === 0) {
          this.$store.dispatch('fetchAddressById', id).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.fetchAddressById')
            })
          })
        } else {
          this.$store.commit('setCurrentAddress', filteredAddresses[0])
        }

        if (this.isPolicyHolder) {
          this.$store.dispatch('fetchAddresses')
          this.$store.dispatch('fetchContractsByAddress', id).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.contractsByAddress')
            })
          })
        }
      } else {
        this.$router.replace('/addresses')
      }
    },
    destroyed () {
      this.$store.commit('setCurrentAddress', {})
    },
    methods: {
      back () {
        this.$router.push('/addresses')
      },
      cancel () {
        this.isEditable = false
      },
      updateContractsWithAddress () {
        this.$store.dispatch('updateContractsWithAddress', {
          oldAddressId: this.currentAddress.id,
          newAddressId: this.newAddress.id
        }).then(() => {
          this.showSuccessMsg({
            message: this.$t('message.addressDetails.changedAdresses')
          })
        }).catch(() => {
          this.showErrorMsg({
            message: this.$t('error.addressDetails.changedAdresses')
          })
        })
      },
      deleteAddress () {
        this.$store.dispatch('deleteAddressById', this.currentAddress.id)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.addressDetails.deleteAddress')
            })
            this.$router.push('/addresses')
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.deleteAddress')
            })
          })
      },
      editAddress () {
        this.isEditable = true
      },
      getAddressBoxClass (address) {
        if (this.newAddress && this.newAddress.id === address.id) {
          return 'address-box__selected'
        }
        return 'address-box_un_selected'
      },
      getTitle (address) {
        return `${address.street} ${address.streetNumber}`
      },
      onSelectAddressbox (address) {
        this.newAddress = address
      },
      onShowDetails (item) {
        this.$router.push(`/contracts/${item.id}`)
      },
      saveAddress () {
        this.$store.dispatch('updateAddress', this.currentAddress)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.addressDetails.saveAddress')
            })
            this.isEditable = false
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.saveAddress')
            })
          })
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>
<style scoped>
  .address-box__selected {
    background-color: rgba(0, 0, 0, .08);
    border: 2px solid #ccc;
  }

  .address-box_un_selected {
    border: 2px solid #ccc;
  }

  .btn-link {
    color: #6c757d;
  }
</style>



// WEBPACK FOOTER //
// src/components/address/AddressDetails.vue